//  **                     -- Shared --                     */
// Getters
export const VALUE = 'shared/VALUE'
export const GET_DRAWER = 'shared/GET_DRAWER'

// Mutations
export const MUTATE_UPDATE_VALUE = 'shared/MUTATE_UPDATE_VALUE'
export const MUTATE_UPDATE_BARIMAGE = 'shared/MUTATE_UPDATE_BARIMAGE'
export const MUTATE_UPDATE_DRAWER = 'shared/MUTATE_UPDATE_DRAWER'
export const MUTATE_UPDATE_SCRIM = 'shared/MUTATE_UPDATE_SCRIM'

// Actions
export const UPDATE_VALUE = 'shared/UPDATE_VALUE'

//  **                     -- Authentication --                     */

// Actions
export const ACTION_AUTH_LOGIN = 'authentication/ACTION_AUTH_LOGIN'

// Mutation
export const MUTATE_AUTH_LOGIN = 'authentication/MUTATE_AUTH_LOGIN'

// Getters
export const GET_AUTH_LOGGEDIN = 'authentication/GET_AUTH_LOGGEDIN'
export const GET_AUTH_USERNAME = 'authentication/GET_AUTH_USERNAME'
export const GET_AUTH_TOKEN = 'authentication/GET_AUTH_TOKEN'
export const GET_AUTH_ROLE = 'authentication/GET_AUTH_ROLE'
